module.exports = __webpack_public_path__ + "img/thumbnail.29729190.jpg";